namespace $.$$ {
	$mol_style_define( $shm_projects_digest_day, {
		flex: { direction: 'column' },
		Head: { flex: { wrap: 'wrap' } },
		Text: { overflowWrap: 'anywhere' },
	} )
	$mol_style_attach( '$shm_projects_digest_day_list_markers', `
		[shm_projects_digest_day_text] [mol_text_list] {
			direction: ltr;
			unicode-bidi: normal;
		}
		[shm_projects_digest_day_text] [mol_text_list_item] {
			position: relative;
			overflow: visible;
			list-style: none;
		}
		[shm_projects_digest_day_text] [mol_text_list_item]::before {
			left: -1.75rem;
			margin-inline-start: 0;
			text-align: right;
		}
	` )
}
